import React from 'react';
import './ChatHistoryInput.css';

function ChatHistoryInput({ value, onChange, placeholder = 'Buscar no histórico...' }) {
    return (
        <div className="chat-history-input-container" data-testid="chat-history-input">
            <img 
                src="/imagens/search.svg" 
                alt="Buscar" 
                className="search-icon search-icon-gray"
            />
            <img 
                src="/imagens/search-icon-blue.svg" 
                alt="Buscar" 
                className="search-icon search-icon-blue"
            />
            <input
                type="text"
                className="chat-history-input"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );
}

export default ChatHistoryInput;
